export default "__VITE_ASSET__DmbemCkd__"